import { Stepper } from "@/components/Stepper"
import { DepositType } from "@usher/pe-client-front-end-lib"
import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import { STEPS } from "../constants"

interface Props {
  step: number
  title?: ReactNode
  depositType?: DepositType
}
export const TopUpSteps = ({ depositType, step, title }: Props) => {
  return (
    <div className="flex items-center flex-col mb-[40px]">
      <h1 className="text-clamp font-bold text-black mb-[40px]">{title ?? <FormattedMessage id="top-up-card" />}</h1>
      <Stepper steps={STEPS(depositType)} currentStep={step} />
    </div>
  )
}
